export const servicePages = [
  {
    slug: "logotherapeia",
    name: "Λογοθεραπεία",
    seoTitle: "Λογοθεραπεία στο Περιστέρι για Παιδιά & Εφήβους | Ορίζοντες Ανάπτυξης",
    metaDescription:
      "Λογοθεραπεία στο Περιστέρι από εξειδικευμένη λογοθεραπεύτρια MSc. Αξιολόγηση & θεραπεία διαταραχών λόγου, ομιλίας και επικοινωνίας. Δωρεάν αξιολόγηση — 210 571 9375.",
    h1: "Λογοθεραπεία στο Περιστέρι",
    handWord: "με τον ρυθμό κάθε παιδιού",
    intro:
      "Στο Κέντρο «Ορίζοντες Ανάπτυξης», δίπλα στο μετρό Αγίου Αντωνίου, βοηθάμε παιδιά και εφήβους με δυσκολίες λόγου, ομιλίας και επικοινωνίας, μέσα από εξατομικευμένα προγράμματα λογοθεραπείας, σε ένα ασφαλές και υποστηρικτικό περιβάλλον.",
    image:
      "/images/services/logotherapeia.jpg",
    imageAlt: "Παιδική ζωγραφιά: παιδί μιλάει με συννεφάκια ομιλίας σε συνεδρία λογοθεραπείας",
    bgColor: "bg-brand-pinkSoft",
    borderColor: "border-brand-pink",
    rooms: ["logotherapeia"],
    sections: [
      {
        h2: "Πότε χρειάζεται ένα παιδί λογοθεραπεία;",
        text: "Κάποια σημάδια που αξίζει να προσέξετε: το παιδί δεν λέει τις πρώτες του λέξεις έως τους 18 μήνες, δεν σχηματίζει απλές προτάσεις έως τα 2,5-3 έτη, μπερδεύει ή παραλείπει ήχους ώστε να μην το καταλαβαίνουν οι άλλοι, ή δυσκολεύεται να κατανοήσει οδηγίες και να εκφράσει αυτό που θέλει. Καμία ανησυχία δεν είναι «υπερβολική» — μια απλή αξιολόγηση δίνει ξεκάθαρη εικόνα και ηρεμία.",
      },
      {
        h2: "Πώς γίνεται η λογοθεραπευτική αξιολόγηση στο κέντρο μας",
        text: "Η πρώτη συνάντηση είναι η αρχή μιας σχέσης συνεργασίας και εμπιστοσύνης. Συζητάμε με τους γονείς τις ανάγκες και τις δυσκολίες που τους απασχολούν, λαμβάνουμε το αναπτυξιακό και ιατρικό ιστορικό και αξιολογούμε το παιδί σε όλους τους αναπτυξιακούς τομείς μέσα από το παιχνίδι, την παρατήρηση και, όπου χρειάζεται, τη χρήση σταθμισμένων αξιολογητικών εργαλείων. Στη συνέχεια, σας ενημερώνουμε αναλυτικά για την εικόνα του παιδιού και, εφόσον χρειάζεται, διαμορφώνουμε ένα εξατομικευμένο θεραπευτικό πλάνο με σαφείς στόχους, πάντα με σεβασμό στη μοναδικότητα και τις ανάγκες του.",
      },
      {
        h2: "Τι περιλαμβάνουν οι συνεδρίες λογοθεραπείας",
        text: "Οι συνεδρίες είναι ατομικές και πλήρως εξατομικευμένες, σχεδιασμένες με βάση τους στόχους του θεραπευτικού πλάνου κάθε παιδιού. Οι γονείς ενημερώνονται τακτικά για την πορεία και συμμετέχουν ενεργά, παίρνοντας πρακτικές ιδέες για το σπίτι, ώστε η πρόοδος να συνεχίζεται και εκτός συνεδρίας.",
      },
    ],
    faq: [
      {
        q: "Σε ποια ηλικία μπορεί να ξεκινήσει η λογοθεραπεία;",
        a: "Δεν υπάρχει «πολύ νωρίς». Ήδη από τους 18-24 μήνες μπορεί να γίνει αξιολόγηση και καθοδήγηση γονέων. Όσο νωρίτερα εντοπιστεί μια δυσκολία, τόσο πιο γρήγορη και ομαλή είναι η εξέλιξη.",
      },
      {
        q: "Το παιδί μου δεν μιλάει ακόμα — πρέπει να ανησυχώ;",
        a: "Κάθε παιδί έχει τον ρυθμό του, όμως η καθυστέρηση ομιλίας δεν πρέπει να αγνοείται με τη λογική «θα μιλήσει όταν είναι έτοιμο». Μια αξιολόγηση θα δείξει αν πρόκειται για απλή καθυστέρηση ή για κάτι που χρειάζεται στήριξη.",
      },
      {
        q: "Πόσο διαρκεί μια συνεδρία λογοθεραπείας;",
        a: "Η τυπική συνεδρία διαρκεί 45 λεπτά και πραγματοποιείται σε συχνότητα που προτείνεται από εμάς, ανάλογα με τις ανάγκες του παιδιού και το θεραπευτικό πλάνο.",
      },
      {
        q: "Η πρώτη αξιολόγηση χρεώνεται;",
        a: "Όχι — στο κέντρο μας η πρώτη αξιολόγηση είναι εντελώς δωρεάν. Καλέστε μας στο 210 571 9375 για να κλείσετε ραντεβού.",
      },
    ],
  },
  {
    slug: "ergotherapeia",
    name: "Εργοθεραπεία",
    seoTitle: "Εργοθεραπεία στο Περιστέρι — Αισθητηριακή Ολοκλήρωση & Snoezelen | Ορίζοντες Ανάπτυξης",
    metaDescription:
      "Εργοθεραπεία παιδιών στο Περιστέρι με εξοπλισμένη αίθουσα Αισθητηριακής Ολοκλήρωσης (SI) και αίθουσα Snoezelen. Λεπτή & αδρή κινητικότητα, αυτοεξυπηρέτηση. Δωρεάν αξιολόγηση.",
    h1: "Εργοθεραπεία στο Περιστέρι",
    handWord: "μέσα από το παιχνίδι",
    intro:
      "Η εργοθεραπεία βοηθά το παιδί να κατακτήσει τις δεξιότητες της καθημερινότητας: να ντύνεται, να κρατά σωστά το μολύβι, να παίζει, να οργανώνεται και να συμμετέχει με αυτοπεποίθηση στο σχολείο και στην παρέα. Στους «Ορίζοντες Ανάπτυξης» διαθέτουμε δύο ειδικά διαμορφωμένες αίθουσες που κάνουν τη θεραπεία μια όμορφη εμπειρία.",
    image:
      "/images/services/ergotherapeia.jpg",
    imageAlt: "Παιδική ζωγραφιά: παιδί παίζει με τουβλάκια και παζλ σε αίθουσα εργοθεραπείας",
    bgColor: "bg-brand-yellowSoft",
    borderColor: "border-brand-yellow",
    rooms: ["si", "snoezelen"],
    sections: [
      {
        h2: "Σε τι βοηθά η εργοθεραπεία τα παιδιά",
        text: "Στηρίζουμε παιδιά που δυσκολεύονται στη λεπτή κινητικότητα (γραφή, κουμπιά, ψαλίδι), στην αδρή κινητικότητα (ισορροπία, συντονισμός), στην αυτοεξυπηρέτηση, στην οργάνωση και τη συγκέντρωση, καθώς και παιδιά με αισθητηριακές ιδιαιτερότητες — που ενοχλούνται έντονα από ήχους, υφές ή κίνηση, ή αντίθετα τα αναζητούν διαρκώς.",
      },
      {
        h2: "Αίθουσα Αισθητηριακής Ολοκλήρωσης (SI)",
        text: "Η αίθουσα SI είναι ένας πλήρως εξοπλισμένος χώρος με κούνιες, στεφάνια, ράμπες και υλικά διαφορετικών υφών. Εδώ το παιδί μαθαίνει, μέσα από στοχευμένο παιχνίδι, να επεξεργάζεται και να οργανώνει τα ερεθίσματα που δέχεται από το σώμα και το περιβάλλον του — θεμέλιο για την κίνηση, τη μάθηση και τη συμπεριφορά.",
      },
      {
        h2: "Αίθουσα Snoezelen — πολυαισθητηριακή χαλάρωση",
        text: "Στην αίθουσα Snoezelen, απαλά φώτα, ήχοι και υφές συνδυάζονται σε ένα ελεγχόμενο αισθητηριακό περιβάλλον. Ανάλογα με τον στόχο, ο χώρος διεγείρει ή χαλαρώνει τις αισθήσεις, βοηθώντας στη μείωση του άγχους, στη ρύθμιση της συμπεριφοράς και στο άνοιγμα της επικοινωνίας.",
      },
    ],
    faq: [
      {
        q: "Πώς καταλαβαίνω ότι το παιδί μου χρειάζεται εργοθεραπεία;",
        a: "Συχνές ενδείξεις: αδέξιες κινήσεις, δυσκολία στη γραφή ή στο ψαλίδι, αποφυγή παιχνιδιών κίνησης, έντονη ενόχληση από ρούχα/ήχους/υφές, δυσκολία στην αυτοεξυπηρέτηση για την ηλικία του. Μια αξιολόγηση θα σας δώσει σαφή απάντηση.",
      },
      {
        q: "Τι είναι η αισθητηριακή ολοκλήρωση;",
        a: "Είναι η ικανότητα του εγκεφάλου να οργανώνει τα ερεθίσματα από τις αισθήσεις (αφή, κίνηση, ισορροπία) ώστε το παιδί να ανταποκρίνεται λειτουργικά. Όταν αυτή η διαδικασία δυσκολεύει, επηρεάζονται το παιχνίδι, η μάθηση και η συμπεριφορά — και εκεί βοηθά η θεραπεία SI.",
      },
      {
        q: "Η αίθουσα Snoezelen είναι κατάλληλη για παιδιά με αυτισμό;",
        a: "Ναι — το ελεγχόμενο πολυαισθητηριακό περιβάλλον είναι ιδιαίτερα ωφέλιμο για παιδιά στο φάσμα του αυτισμού, καθώς βοηθά στη χαλάρωση, στη ρύθμιση και στη σταδιακή εξοικείωση με ερεθίσματα.",
      },
    ],
  },
  {
    slug: "psychologiki-ypostirixi",
    name: "Ψυχολογική Υποστήριξη",
    seoTitle: "Ψυχολογική Υποστήριξη Παιδιών & Εφήβων στο Περιστέρι | Ορίζοντες Ανάπτυξης",
    metaDescription:
      "Ψυχολογική υποστήριξη και συμβουλευτική παιδιών & εφήβων στο Περιστέρι, σε ασφαλές και ζεστό περιβάλλον. Άγχος, συναισθηματικές δυσκολίες, αυτοεκτίμηση. Τηλ: 210 571 9375.",
    h1: "Ψυχολογική Υποστήριξη Παιδιών & Εφήβων",
    handWord: "με ασφάλεια",
    intro:
      "Στο Κέντρο «Ορίζοντες Ανάπτυξης», δίπλα στο μετρό Αγίου Αντωνίου, προσφέρουμε ψυχολογική υποστήριξη σε παιδιά και εφήβους που αντιμετωπίζουν συναισθηματικές, συμπεριφορικές ή κοινωνικές δυσκολίες, σε ένα ασφαλές και υποστηρικτικό περιβάλλον, πάντα με σεβασμό στη μοναδικότητα και τις ανάγκες του κάθε παιδιού.",
    image:
      "/images/services/psychologiki-ypostirixi.jpg",
    imageAlt: "Παιδική ζωγραφιά: παιδί με μεγάλη καρδιά και υποστηρικτικός ενήλικας δίπλα του",
    bgColor: "bg-brand-blueSoft",
    borderColor: "border-brand-blue",
    rooms: ["psychologiki"],
    sections: [
      {
        h2: "Πότε βοηθά η ψυχολογική υποστήριξη",
        text: "Η ψυχολογική υποστήριξη μπορεί να βοηθήσει παιδιά και εφήβους που βιώνουν έντονο άγχος ή φοβίες, δυσκολίες στη διαχείριση των συναισθημάτων, εκρήξεις θυμού, χαμηλή αυτοεκτίμηση, δυσκολίες στις σχέσεις με συνομηλίκους, αλλαγές στη διάθεση ή δυσκολεύονται να προσαρμοστούν σε σημαντικές αλλαγές της ζωής τους. Στόχος μας είναι να νιώσουν μεγαλύτερη ασφάλεια, να κατανοήσουν τα συναισθήματά τους και να αναπτύξουν υγιείς τρόπους διαχείρισής τους.",
      },
      {
        h2: "Πώς δουλεύουμε",
        text: "Η πρώτη συνάντηση είναι η αρχή μιας σχέσης συνεργασίας και εμπιστοσύνης. Συζητάμε με τους γονείς τις ανάγκες και τις δυσκολίες που τους απασχολούν, λαμβάνουμε το αναπτυξιακό και οικογενειακό ιστορικό και γνωρίζουμε το παιδί μέσα από δραστηριότητες και συζήτηση, ανάλογα με την ηλικία και τις ανάγκες του. Στη συνέχεια, σας ενημερώνουμε για την εικόνα του παιδιού και, εφόσον χρειάζεται, διαμορφώνουμε ένα εξατομικευμένο πλάνο υποστήριξης με σαφείς στόχους.",
        text2: "Η θεραπευτική σχέση βασίζεται στην εμπιστοσύνη και τον σεβασμό. Στα μικρότερα παιδιά αξιοποιούμε το θεραπευτικό παιχνίδι και δημιουργικές δραστηριότητες, ενώ με τους εφήβους η παρέμβαση προσαρμόζεται στις ανάγκες και τον τρόπο επικοινωνίας τους. Παράλληλα, συνεργαζόμαστε στενά με την οικογένεια, παρέχοντας καθοδήγηση και τακτική ενημέρωση για την πορεία του παιδιού.",
      },
    ],
    faq: [
      {
        q: "Πώς θα καταλάβω αν το παιδί μου χρειάζεται ψυχολογική υποστήριξη;",
        a: "Αν παρατηρείτε αλλαγές στη διάθεση, στη συμπεριφορά, στον ύπνο, στις σχέσεις ή στη λειτουργικότητα του παιδιού που επιμένουν και επηρεάζουν την καθημερινότητά του, μια συνάντηση αξιολόγησης μπορεί να σας βοηθήσει να κατανοήσετε καλύτερα τις ανάγκες του.",
      },
      {
        q: "Θα ενημερώνομαι για όσα συζητά το παιδί στις συνεδρίες;",
        a: "Η σχέση εμπιστοσύνης με το παιδί είναι βασική προϋπόθεση της θεραπευτικής διαδικασίας. Οι γονείς ενημερώνονται τακτικά για την πορεία, τους στόχους και τον τρόπο με τον οποίο μπορούν να υποστηρίξουν το παιδί, πάντα με σεβασμό στην ιδιωτικότητα και την ηλικία του.",
      },
      {
        q: "Πόσο θα διαρκέσει η θεραπεία;",
        a: "Η διάρκεια εξαρτάται από τις ανάγκες του κάθε παιδιού και τη δυσκολία που αντιμετωπίζει. Μετά τις πρώτες συναντήσεις θα έχουμε μια πιο ολοκληρωμένη εικόνα και θα συζητήσουμε μαζί σας το κατάλληλο πλάνο υποστήριξης.",
      },
    ],
  },
  {
    slug: "proimi-paremvasi",
    name: "Πρώιμη Παρέμβαση",
    seoTitle: "Πρώιμη Παρέμβαση στο Περιστέρι για Μικρά Παιδιά έως Νήπια | Ορίζοντες Ανάπτυξης",
    metaDescription:
      "Πρόγραμμα πρώιμης παρέμβασης στο Περιστέρι για μικρά παιδιά έως νήπια με αναπτυξιακές δυσκολίες ή καθυστέρηση. Έγκαιρη στήριξη σε συνεργασία με την οικογένεια. Δωρεάν αξιολόγηση.",
    h1: "Πρώιμη Παρέμβαση",
    handWord: "από τα πρώτα βήματα",
    intro:
      "Τα πρώτα χρόνια της ζωής αποτελούν μια ιδιαίτερα σημαντική περίοδο για την ανάπτυξη του παιδιού. Η πρώιμη παρέμβαση προσφέρει έγκαιρη και εξατομικευμένη υποστήριξη σε βρέφη, νήπια και παιδιά προσχολικής ηλικίας που παρουσιάζουν δυσκολίες ή χρειάζονται ενίσχυση στην ανάπτυξη των δεξιοτήτων τους. Στις μικρές ηλικίες ο εγκέφαλος αναπτύσσεται και προσαρμόζεται με εντυπωσιακή ταχύτητα, δημιουργώντας τις καλύτερες προϋποθέσεις για μάθηση και εξέλιξη. Γι' αυτό, η έγκαιρη υποστήριξη μπορεί να κάνει ουσιαστική διαφορά στην πορεία του παιδιού, πάντα με σεβασμό στη μοναδικότητα και τις ανάγκες του.",
    image:
      "/images/services/proimi-paremvasi.jpg",
    imageAlt: "Παιδική ζωγραφιά: μικρό παιδί παίζει με τουβλάκια κάτω από ουράνιο τόξο",
    bgColor: "bg-brand-secondarySoft",
    borderColor: "border-brand-secondary",
    rooms: ["proimi"],
    sections: [
      {
        h2: "Γιατί η έγκαιρη παρέμβαση κάνει τη διαφορά",
        text: "Η έγκαιρη αναγνώριση και αντιμετώπιση των δυσκολιών μπορεί να συμβάλει σημαντικά στην αναπτυξιακή πορεία του παιδιού. Μέσα από ένα εξατομικευμένο πρόγραμμα παρέμβασης ενισχύονται σταδιακά οι δεξιότητες επικοινωνίας, κίνησης, παιχνιδιού, μάθησης και κοινωνικής αλληλεπίδρασης. Παράλληλα, οι γονείς λαμβάνουν την απαραίτητη καθοδήγηση, ώστε να μπορούν να υποστηρίζουν αποτελεσματικά το παιδί και στην καθημερινότητά του.",
      },
      {
        h2: "Πώς δουλεύουμε",
        text: "Η πρώτη συνάντηση είναι η αρχή μιας σχέσης συνεργασίας και εμπιστοσύνης. Συζητάμε με τους γονείς τις ανησυχίες και τις ανάγκες τους, λαμβάνουμε το αναπτυξιακό και ιατρικό ιστορικό και αξιολογούμε το παιδί στους βασικούς αναπτυξιακούς τομείς μέσα από το παιχνίδι, την παρατήρηση και, όπου χρειάζεται, τη χρήση σταθμισμένων αξιολογητικών εργαλείων. Στη συνέχεια, σας ενημερώνουμε αναλυτικά για την εικόνα του παιδιού και, εφόσον χρειάζεται, διαμορφώνουμε ένα εξατομικευμένο πρόγραμμα πρώιμης παρέμβασης με σαφείς θεραπευτικούς στόχους.",
        text2: "Το πρόγραμμα σχεδιάζεται εξατομικευμένα, σύμφωνα με τις ανάγκες του κάθε παιδιού, και μπορεί να περιλαμβάνει λογοθεραπεία, εργοθεραπεία και ψυχοπαιδαγωγική υποστήριξη, όταν αυτό κρίνεται απαραίτητο. Όλες οι παρεμβάσεις πραγματοποιούνται μέσα από το παιχνίδι και δραστηριότητες κατάλληλες για την ηλικία του παιδιού. Παράλληλα, η οικογένεια αποτελεί ενεργό μέρος της θεραπευτικής διαδικασίας, καθώς παρέχουμε πρακτική καθοδήγηση και στρατηγικές που μπορούν να εφαρμοστούν στην καθημερινότητα.",
      },
    ],
    faq: [
      {
        q: "Ποιες ηλικίες αφορά η πρώιμη παρέμβαση;",
        a: "Η πρώιμη παρέμβαση απευθύνεται κυρίως σε βρέφη, νήπια και παιδιά προσχολικής ηλικίας, συνήθως έως την ηλικία των 4–5 ετών. Αν υπάρχουν ανησυχίες για την ανάπτυξη του παιδιού, η έγκαιρη αξιολόγηση μπορεί να δώσει πολύτιμες απαντήσεις και κατευθύνσεις.",
      },
      {
        q: "Ποια σημάδια μπορεί να χρειάζονται αξιολόγηση;",
        a: "Ενδείξεις όπως καθυστέρηση στην ομιλία ή στην κίνηση, περιορισμένη βλεμματική επαφή, δυσκολία στην ανταπόκριση στο όνομά του, περιορισμένο παιχνίδι ή δυσκολίες στην κοινωνική αλληλεπίδραση είναι λόγοι που αξίζει να αξιολογηθούν από έναν ειδικό. Η παρουσία ενός μόνο χαρακτηριστικού δεν σημαίνει απαραίτητα ότι υπάρχει κάποια διαταραχή, όμως η έγκαιρη εκτίμηση είναι πάντα χρήσιμη.",
      },
      {
        q: "Συμμετέχουν οι γονείς στις συνεδρίες;",
        a: "Ναι. Η ενεργή συμμετοχή της οικογένειας αποτελεί βασικό μέρος της φιλοσοφίας μας. Σας καθοδηγούμε ώστε να εφαρμόζετε απλές και πρακτικές στρατηγικές στην καθημερινότητα, ενισχύοντας τη γενίκευση των δεξιοτήτων και την πρόοδο του παιδιού.",
      },
    ],
  },
  {
    slug: "symvouleftiki-goneon",
    name: "Συμβουλευτική Γονέων",
    seoTitle: "Συμβουλευτική Γονέων στο Περιστέρι | Ορίζοντες Ανάπτυξης",
    metaDescription:
      "Συμβουλευτική γονέων στο Περιστέρι: πρακτική καθοδήγηση για όρια, συμπεριφορά, ρουτίνες και στήριξη παιδιών με δυσκολίες. Ατομικές συναντήσεις σε ζεστό περιβάλλον.",
    h1: "Συμβουλευτική Γονέων",
    handWord: "δίπλα σε κάθε οικογένεια",
    intro:
      "Το να είσαι γονιός είναι ο πιο όμορφος — και συχνά ο πιο απαιτητικός — ρόλος. Δεν υπάρχει μία σωστή συνταγή για τη γονεϊκότητα. Η συμβουλευτική γονέων είναι ένας ασφαλής χώρος, όπου μπορείτε να μιλήσετε ανοιχτά για όσα σας απασχολούν, χωρίς φόβο ή κριτική, και να βρείτε πρακτικές λύσεις που ανταποκρίνονται στις ανάγκες της δικής σας οικογένειας.",
    image:
      "/images/services/symvouleftiki-goneon.jpg",
    imageAlt: "Παιδική ζωγραφιά: γονείς κρατούν τα χέρια του παιδιού τους κάτω από τον ήλιο",
    bgColor: "bg-brand-purpleSoft",
    borderColor: "border-brand-purple",
    rooms: ["ypodochi"],
    roomPhotoCount: 1,
    sections: [
      {
        h2: "Σε ποια θέματα μπορούμε να σας στηρίξουμε",
        text: "Η συμβουλευτική γονέων απευθύνεται σε οικογένειες που αναζητούν καθοδήγηση σε θέματα όπως η οριοθέτηση, η διαχείριση έντονων συναισθημάτων και δύσκολων συμπεριφορών, οι καθημερινές ρουτίνες, οι σχέσεις μεταξύ αδελφών, η προσαρμογή σε σημαντικές αλλαγές, καθώς και η υποστήριξη παιδιών που παρακολουθούν θεραπευτικά προγράμματα. Στόχος μας είναι να σας προσφέρουμε πρακτικά εργαλεία και στρατηγικές που μπορούν να εφαρμοστούν στην καθημερινότητα, ενισχύοντας τη σχέση σας με το παιδί.",
      },
      {
        h2: "Πώς γίνονται οι συναντήσεις",
        text: "Η πρώτη συνάντηση είναι η αρχή μιας σχέσης συνεργασίας και εμπιστοσύνης. Συζητάμε τις ανάγκες, τις δυσκολίες και τους προβληματισμούς που αντιμετωπίζετε στην καθημερινότητα με το παιδί σας και λαμβάνουμε ένα ολοκληρωμένο οικογενειακό ιστορικό. Μαζί διερευνούμε τι μπορεί να κρύβεται πίσω από τις συμπεριφορές που σας προβληματίζουν και διαμορφώνουμε ένα εξατομικευμένο πλάνο με μικρά, ρεαλιστικά και εφαρμόσιμα βήματα. Στις επόμενες συναντήσεις αξιολογούμε την πορεία, συζητάμε όσα λειτούργησαν στην πράξη και προσαρμόζουμε το πλάνο στις ανάγκες της οικογένειάς σας.",
      },
    ],
    faq: [
      {
        q: "Χρειάζεται να έρθει και το παιδί στη συμβουλευτική γονέων;",
        a: "Όχι. Οι συναντήσεις πραγματοποιούνται με τους γονείς. Αν κατά τη διάρκεια της συνεργασίας διαπιστωθεί ότι θα ήταν ωφέλιμη μια αξιολόγηση ή υποστήριξη του παιδιού, θα το συζητήσουμε μαζί σας.",
      },
      {
        q: "Μπορούμε να συμμετέχουμε και οι δύο γονείς;",
        a: "Βεβαίως. Η συμμετοχή και των δύο γονέων, όταν είναι εφικτή, βοηθά στη διαμόρφωση μιας κοινής στάσης απέναντι στις ανάγκες του παιδιού. Ωστόσο, οι συναντήσεις μπορούν να πραγματοποιηθούν και με έναν μόνο γονέα.",
      },
      {
        q: "Η συμβουλευτική γονέων απευθύνεται μόνο σε οικογένειες που αντιμετωπίζουν δυσκολίες;",
        a: "Όχι. Η συμβουλευτική γονέων μπορεί να φανεί χρήσιμη σε κάθε γονέα που επιθυμεί να κατανοήσει καλύτερα το παιδί του, να ενισχύσει τη μεταξύ τους σχέση και να διαχειριστεί με μεγαλύτερη σιγουριά τις προκλήσεις της καθημερινότητας.",
      },
    ],
  },
  {
    slug: "therapeia-sitisis",
    name: "Θεραπεία Σίτισης",
    seoTitle: "Θεραπεία Σίτισης — Τροφική Επιλεκτικότητα Παιδιών | Ορίζοντες Ανάπτυξης Περιστέρι",
    metaDescription:
      "Θεραπεία σίτισης στο Περιστέρι για παιδιά και εφήβους με τροφική επιλεκτικότητα και δυσκολίες στο φαγητό. Ήρεμη, σταδιακή προσέγγιση χωρίς πίεση. Τηλ: 210 571 9375.",
    h1: "Θεραπεία Σίτισης & Τροφική Επιλεκτικότητα",
    handWord: "όταν το γεύμα γίνεται πρόκληση για την οικογένεια",
    intro:
      "«Τρώει μόνο 5 συγκεκριμένα φαγητά», «δυσκολεύεται με ορισμένες υφές», «κάθε γεύμα συνοδεύεται από ένταση» — αν αυτές οι φράσεις περιγράφουν την καθημερινότητά σας, δεν είστε μόνοι. Η έντονη τροφική επιλεκτικότητα αποτελεί μια πραγματική αναπτυξιακή και αισθητηριακή δυσκολία, η οποία χρειάζεται εξειδικευμένη υποστήριξη. Στο κέντρο μας «Ορίζοντες Ανάπτυξης», προσεγγίζουμε τη σίτιση με απόλυτο σεβασμό στις ανάγκες και τα όρια του παιδιού, εφαρμόζοντας σύγχρονες μεθόδους χωρίς πίεση.",
    image:
      "/images/services/therapeia-sitisis.jpg",
    imageAlt: "Παιδική ζωγραφιά: χαρούμενο παιδί σε τραπεζάκι με πιάτο γεμάτο φρούτα και λαχανικά",
    bgColor: "bg-brand-pinkSoft",
    borderColor: "border-brand-pink",
    sections: [
      {
        h2: "Τι κρύβεται πίσω από την τροφική επιλεκτικότητα;",
        text: "Η δυσκολία αποδοχής νέων τροφών είναι το αποτέλεσμα οργανικών ή λειτουργικών παραγόντων που επηρεάζουν το παιδί. Οι συνηθέστερες αιτίες περιλαμβάνουν:",
        bullets: [
          {
            t: "Αισθητηριακές ιδιαιτερότητες:",
            d: "Διαφορετική επεξεργασία σε συγκεκριμένες υφές, μυρωδιές, θερμοκρασίες ή και στην όψη των τροφίμων.",
          },
          {
            t: "Στοματοκινητικές δυσκολίες:",
            d: "Ανάγκη για ενίσχυση του ελέγχου των μυών του στόματος, που επηρεάζει τη μάσηση ή την κατάποση.",
          },
          {
            t: "Αρνητικές καταγραφές:",
            d: "Προηγούμενες σωματικές ενοχλήσεις, όπως γαστροοισοφαγική παλινδρόμηση ή εμπειρίες που προκάλεσαν στρες στο τραπέζι.",
          },
        ],
        note: "Σημείωση: Οι δυσκολίες αυτές εμφανίζονται συχνά σε παιδιά με διαταραχές αισθητηριακής επεξεργασίας, καθώς και στο φάσμα του αυτισμού (ΔΑΦ).",
      },
      {
        h2: "Η θεραπευτική μας προσέγγιση: Βήμα-βήμα, με το ρυθμό του παιδιού",
        text: "Η σχέση με το φαγητό αναδομείται θετικά, μέσα σε ένα περιβάλλον ασφάλειας και σταθερότητας.",
        bullets: [
          {
            t: "Ολιστική αξιολόγηση:",
            d: "Καταγράφουμε το αναπτυξιακό ιστορικό, το εύρος των τροφών που ήδη καταναλώνονται και το αισθητηριακό προφίλ του παιδιού.",
          },
          {
            t: "Παιχνίδι εξοικείωσης:",
            d: "Χρησιμοποιούμε το παιχνίδι ως βασικό θεραπευτικό εργαλείο. Το παιδί αγγίζει, επεξεργάζεται και εξερευνά τα τρόφιμα χωρίς το άγχος της δοκιμής.",
          },
          {
            t: "Σταδιακή έκθεση:",
            d: "Το παιδί προσεγγίζει τις νέες τροφές με τον δικό του ρυθμό, περνώντας σταδιακά από την οπτική ανοχή στην αφή και στη συνέχεια στη γεύση.",
          },
          {
            t: "Συμβουλευτική γονέων:",
            d: "Σας καθοδηγούμε με πρακτικές στρατηγικές, ώστε τα γεύματα στο σπίτι να μετατραπούν σε μια ήρεμη και ευχάριστη οικογενειακή στιγμή.",
          },
        ],
      },
    ],
    faq: [
      {
        q: "Το παιδί μου τρώει ελάχιστα φαγητά. Πότε είναι χρήσιμο να ζητήσω βοήθεια;",
        a: "Αν η διατροφή του παιδιού περιλαμβάνει λιγότερα από 15-20 τρόφιμα, αν αποκλείονται ολόκληρες ομάδες τροφών ή αν η ώρα του φαγητού προκαλεί έντονο άγχος, η έγκαιρη αξιολόγηση βοηθά στην ομαλή αναπτυξιακή του πορεία και στη σταδιακή διεύρυνση των επιλογών του με θετικό τρόπο.",
      },
      {
        q: "Πώς διασφαλίζεται ότι δεν θα υπάρξει πίεση στο παιδί;",
        a: "Η επιστημονική έρευνα επιβεβαιώνει ότι η πίεση φέρνει τα αντίθετα αποτελέσματα. Στο κέντρο μας, το παιδί διατηρεί τον έλεγχο των ορίων του. Δημιουργούμε εσωτερικά κίνητρα και θετική διάθεση για εξερεύνηση, χωρίς κανέναν απολύτως εξαναγκασμό.",
      },
      {
        q: "Πόσο άμεσα εκδηλώνεται η πρόοδος;",
        a: "Κάθε παιδί ακολουθεί τη δική του πορεία και η θεραπεία σίτισης απαιτεί σταθερά βήματα. Ωστόσο, οι πρώτες θετικές αλλαγές —όπως η μείωση του στρες στο τραπέζι και η αποδοχή της παρουσίας μιας νέας τροφής στο πιάτο— εμφανίζονται σύντομα.",
      },
    ],
  },
];
